import { render } from "./FriendlyModelSelector.vue?vue&type=template&id=c6f83aee&scoped=true"
import script from "./FriendlyModelSelector.vue?vue&type=script&lang=js"
export * from "./FriendlyModelSelector.vue?vue&type=script&lang=js"

import "./FriendlyModelSelector.vue?vue&type=style&index=0&id=c6f83aee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f83aee"]])

export default __exports__